import styled from "@emotion/styled";
import theme from "../../styles/theme";
import CTA from "../cta/cta";

export const AnnouncementBannerBackground = styled.div`
  background: linear-gradient(135.48deg, #1771f1 0%, #5195f5 100%);
  position: sticky;
  z-index: 20;
  top: 0;
  box-sizing: border-box;

  * {
    box-sizing: border-box;
  }
`;

export const AnnouncementBannerContent = styled.div`
  padding: 8px 12px;
  display: flex;
  align-items: center;
  justify-content: center;

  button {
    border: none !important;
  }
`;

export const AnnouncementBannerTitles = styled.div`
  color: #ffffff;
  font-size: ${theme.fontSize.xs};
  line-height: ${theme.leading.tight};
  text-align: center;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;

  ${theme.largerThan.md} {
    flex: 2;
    flex: initial;
    margin-bottom: 0;
    font-size: ${theme.fontSize.sm};
    line-height: 20px;
  }
`;

export const AnnouncementBannerTitle = styled.span`
  font-weight: ${theme.fontWeights.semibold};
  overflow: hidden;
  vertical-align: middle;

  ${theme.smallerThan.md} {
    display: -webkit-box;
    -webkit-line-clamp: 2; /* number of lines to show */
    line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  ${theme.largerThan.lg} {
    display: inline-block;
    max-width: 700px;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`;

export const AnnouncementBannerSubtitle = styled.span`
  margin-left: ${theme.spacing[1]};
  vertical-align: middle;
`;

export const AnnouncementBannerCTAContainer = styled.div`
  text-align: center;
  line-height: 1;
`;

export const AnnouncementBannerCTA = styled(CTA)`
  white-space: nowrap;
  display: inline-block;
  background: transparent;
  border: 0;
  padding: 0 !important;
  line-height: ${theme.leading.tight};
  text-decoration: underline;
  font-size: ${theme.fontSize.sm};

  &:hover {
    background-color: transparent;
    color: ${theme.colors.darkBlues[100]};
  }
`;
